var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { type: "flex", justify: "space-between" }
                },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.formTitle))]),
                  _vm._v(" "),
                  _vm.$parent.user_is_admin
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("canceled")
                            }
                          }
                        },
                        [_vm._v("Schliessen")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "supplierData",
              attrs: {
                model: _vm.supplierData,
                "label-width": "300px",
                "label-position": "left",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Name Supplier", prop: "supplier_name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.supplier_name,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "supplier_name", $$v)
                      },
                      expression: "supplierData.supplier_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "SMTP Host", prop: "mail_smtp" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_smtp,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "mail_smtp", $$v)
                      },
                      expression: "supplierData.mail_smtp"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "SMTP Port", prop: "mail_smtp_port" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_smtp_port,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.supplierData,
                          "mail_smtp_port",
                          _vm._n($$v)
                        )
                      },
                      expression: "supplierData.mail_smtp_port"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "SMTP Verschlüsselung",
                    prop: "mail_smtp_encryption"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_smtp_encryption,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "mail_smtp_encryption", $$v)
                      },
                      expression: "supplierData.mail_smtp_encryption"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "SMTP Benutzername",
                    prop: "mail_smtp_username"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_smtp_username,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "mail_smtp_username", $$v)
                      },
                      expression: "supplierData.mail_smtp_username"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "SMTP Passwort", prop: "mail_smtp_password" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_smtp_password,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "mail_smtp_password", $$v)
                      },
                      expression: "supplierData.mail_smtp_password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Kontakt-Mail", prop: "contact_mail" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.contact_mail,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "contact_mail", $$v)
                      },
                      expression: "supplierData.contact_mail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Zugelassene Anzahl von Panels pro Kunde",
                    prop: "max_panels_per_customer"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "number" },
                    model: {
                      value: _vm.supplierData.max_panels_per_customer,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.supplierData,
                          "max_panels_per_customer",
                          $$v
                        )
                      },
                      expression: "supplierData.max_panels_per_customer"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Absender-Mail", prop: "mail_sender_address" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.mail_sender_address,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "mail_sender_address", $$v)
                      },
                      expression: "supplierData.mail_sender_address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Rabatt pro Panel",
                    prop: "discount_per_panel"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.discount_per_panel,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "discount_per_panel", $$v)
                      },
                      expression: "supplierData.discount_per_panel"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Schriftfarbe", prop: "font_color" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.font_color,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "font_color", $$v)
                      },
                      expression: "supplierData.font_color"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Hintergrundfarbe", prop: "background_color" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.background_color,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "background_color", $$v)
                      },
                      expression: "supplierData.background_color"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Hervorhebungsfarbe",
                    prop: "highlight_color"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.highlight_color,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "highlight_color", $$v)
                      },
                      expression: "supplierData.highlight_color"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Applikations-URL", prop: "permalink_url" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.supplierData.permalink_url,
                      callback: function($$v) {
                        _vm.$set(_vm.supplierData, "permalink_url", $$v)
                      },
                      expression: "supplierData.permalink_url"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Logo", prop: "logo" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "show-file-list": !_vm.logoUploaded,
                        "file-list": _vm.fileList,
                        "on-change": _vm.uploadAndPreview,
                        "auto-upload": false,
                        "on-remove": _vm.handleRemove,
                        "list-type": "picture"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.uploading,
                            size: "small",
                            type: "primary"
                          }
                        },
                        [_vm._v("Hochladen")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [_vm._v("jpg/png files with a size less than 500kb")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.uploading, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("supplierData")
                        }
                      }
                    },
                    [_vm._v("Speichern\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.uploading },
                      on: {
                        click: function($event) {
                          return _vm.cancelForm("supplierData")
                        }
                      }
                    },
                    [_vm._v("Abbrechen\n                ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01abdef3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01abdef3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/suppliers/SupplierForm.vue
// module id = null
// module chunks = 